import { createTheme } from '@mui/material/styles';

import { breakpointValues } from './constants';
import fonts from './fonts';
import { getMobileBottomSheetPaperRow } from './mobile-bottom-sheet-paper';

export const formControlCommon = {
  outlinedInput: {
    borderRadius: '10px',
    padding: '8px 10px !important',
    fontSize: '1rem',
    fontFamily: ['Open Sans', 'Manrope', 'Coolvetica', 'sans-serif'].join(','),
  },
  input: {
    padding: '0',
    fontFamily: 'inherit',
  },
  select: {
    padding: '8px 32px 8px 10px !important',
  },
} as const;

const theme = createTheme({ breakpoints: breakpointValues });

export default {
  MuiCssBaseline: {
    styleOverrides: fonts,
  },
  MuiFormControl: {
    styleOverrides: {
      root: ({ theme: t }) => ({
        '& .MuiOutlinedInput-root': {
          ...formControlCommon.outlinedInput,
          backgroundColor: t.palette.input.main,
          '& fieldset': {
            border: `1px solid ${t.palette.border.main}`,
          },
          '&:not(.Mui-focused):not(.Mui-disabled):hover fieldset': {
            border: `1px solid ${t.palette.primary.main}`,
          },
          '&.Mui-disabled': {
            backgroundColor: t.palette.input.disabled,
          },
        },
        '& .MuiOutlinedInput-root:has(.MuiSelect-select)': {
          padding: '0 !important',
        },
        '& input': {
          ...formControlCommon.input,
          '&:-webkit-autofill': {
            WebkitBoxShadow: `0 0 0 1000px ${t.palette.background.paper} inset`,
          },
        },
        '& .MuiAutocomplete-input': {
          fontFamily: 'inherit',
          padding: '0 !important',
        },
        '& .MuiSelect-select': {
          ...formControlCommon.select,
          boxSizing: 'border-box',
        },
      }),
    },
  },
  MuiInputAdornment: {
    styleOverrides: {
      root: ({ theme: t }) => ({
        '& svg': {
          color: t.palette.primary.main,
        },
      }),
    },
  },
  MuiFormLabel: {
    styleOverrides: {
      asterisk: ({ theme: t }) => ({
        color: t.palette.primary.main,
        '&$error': {
          color: t.palette.primary.main,
        },
      }),
    },
  },
  MuiMenu: {
    styleOverrides: {
      root: {
        '& .MuiBackdrop-root': {
          [theme.breakpoints.down('md')]: {
            background: 'rgba(0, 0, 0, 0.3)',
          },
        },

        '& .MuiPaper-root': {
          [theme.breakpoints.down('md')]: {
            ...getMobileBottomSheetPaperRow(),
          },
        },
      },
    },
  },
};
